import { mygolfUtils } from './../../../../custom/mygolf2u-utils';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { EInvoiceInfoPage } from './../e-invoice-info/e-invoice-info.page';
import { EInvoicingEntity, EInvoicingSetup, Order } from './../../../../data/mygolf.data';
import { PlayerData, TBookingEInvoicePlayerDTO, TeeTimeBooking, TeeTimeBookingPlayer } from 'src/data/mygolf.data';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { AddPlayerListPage } from '../add-player-list/add-player-list.page';

export interface InvoicePlayer {
  bookingPlayerId?: number;
  playerId?: number;
  einvoiceEntity?: EInvoicingSetup;
  playerData?: PlayerData;
  customerInfo?: any;
}
@Component({
  selector: 'app-e-invoice-validator',
  templateUrl: './e-invoice-validator.component.html',
  styleUrls: ['./e-invoice-validator.component.scss'],
})
export class EInvoiceValidatorComponent implements OnInit {
  @Input() bookingType: any;
  @Input() bookingSlot: TeeTimeBooking;
  @Input() arrivalOption: any;
  @Input() checkInPlayers: any;
  @Input() etaCounter: number = 30;
  @Input() checkInAllPlayers: boolean = false;
  @Input() getPlayerSlotDetails: (slot: number, attribute: string) => void;
  @Input() orderDetails: Order;

  playerList: Array<PlayerData> = [];
  bookingPlayers: Array<TeeTimeBookingPlayer> = [];

  teeBookingEInvoicePlayerDTO: Array<TBookingEInvoicePlayerDTO> = [];

  selectedPlayers: Array<TeeTimeBookingPlayer> = [];
  selectedInvoicePlayers: Array<TeeTimeBookingPlayer> = [];
  addInvoiceCustomerType: string = 'booking'; // booking | mg2u | adhoc
  invoiceCustomerType: Array<any> = [
    {
      id: 'booking',
      name: 'Booking Player',
      forInvoiceType: 't-booking',
    },
    {
      id: 'mg2u',
      name: 'myGolf2u Player',
      forInvoiceType: null,
    },
    {
      id: 'adhoc',
      name: 'Not in myGolf2u',
      forInvoiceType: null,
    },
  ];
  @Input() invoiceType: string = 't-booking';
  selectedInvoicePlayer: InvoicePlayer = {
    bookingPlayerId: null,
    playerId: null,
    einvoiceEntity: null,
    playerData: null,
  };
  constructor(
    public platform: Platform,
    private modalCtl: ModalController,
    private flightService: ClubFlightService,
    private toastCtrl: ToastController,
    private mg2uUtils: mygolfUtils
  ) {}

  ngOnInit() {
    console.debug('on init - booking slot : ', this.bookingSlot, this.invoiceType, this.orderDetails);
    if (this.invoiceType === 'order') {
      console.debug('on init - invoice type [0] : ', this.invoiceType);
      console.debug('on init - invoice type [1] : ', this.orderDetails);
      console.debug('on init - invoice type [2] : ', this.getOrderCustomerInfo());
      if (this.orderDetails) {
        this.selectedInvoicePlayer.customerInfo = this.getOrderCustomerInfo();
        this.selectedInvoicePlayer.einvoiceEntity = this.getClubCustomerEInvoiceEntity();
      }
    } else {
      if (this.bookingSlot?.bookingPlayers) {
        this.bookingPlayers.push(...this.bookingSlot?.bookingPlayers);
        const mg2uBookingPlayers = this.bookingPlayers?.filter(bp => bp?.player);
        this.getAllPlayerDetails(mg2uBookingPlayers, 0);
      }
    }
  }

  addETAcounter(type: number) {
    if (type > 0 && this.etaCounter === 60) return false;
    else if (type < 0 && this.etaCounter === 0) return false;
    if (type === 1) this.etaCounter += 5;
    else if (type === -1) this.etaCounter -= 5;
  }

  onCheckInAll() {
    if (this.checkInAllPlayers) {
      this.checkInPlayers = [true, true, true, true, true, true];
    } else {
      this.checkInPlayers = [false, false, false, false, false, false];
    }
  }

  saveAndDismiss(save: boolean) {
    if (save) {
      this.modalCtl.dismiss({
        etaCounter: this.etaCounter,
        arrivalOption: this.arrivalOption,
        checkInPlayers: this.checkInPlayers,
        checkInAllPlayers: this.checkInAllPlayers,
      });
    } else {
      this.modalCtl.dismiss();
    }
  }

  getAllPlayerDetails(mg2uPlayers: Array<TeeTimeBookingPlayer>, counter = 0) {
    if (counter >= mg2uPlayers?.length) return;
    this.getPlayerDetails(mg2uPlayers[counter]?.player?.id).then((result: any) => {
      if (result) {
        console.debug('has complete einvoice - result : ', counter, mg2uPlayers, result);
        this.playerList.push(result);
        counter += 1;
        this.getAllPlayerDetails(mg2uPlayers, counter);
      }
    });
  }

  getPlayerDetails(playerId) {
    return new Promise((resolve, reject) => {
      this.flightService.getPlayerDetails(playerId).subscribe((playerData: PlayerData) => {
        if (playerData) {
          resolve(playerData);
        }
      });
    });
  }

  // hasCompleteEInvoice(bookingPlayer: TeeTimeBookingPlayer) {
  //   console.debug('has complete einvoice : ', bookingPlayer, this.playerList);
  //   if (!bookingPlayer?.player) return;
  //   const playerData = this.playerList?.find((p: PlayerData) => {
  //     return p?.id === bookingPlayer?.player?.id;
  //   });
  //   return this.onValidateEInvoice(playerData);
  // }

  hasCompleteEInvoice() {
    if (!this.selectedInvoicePlayer?.einvoiceEntity) return false;
    return this.onValidateEInvoice()?.success;
  }

  parseValidationMessages() {
    if (this.onValidateEInvoice()?.success) return;
    return this.onValidateEInvoice()?.messages?.join('<br>');
  }

  onValidatePlayerEInvoice(playerData: PlayerData) {
    if (!playerData) return;
    let eInvoiceInfo = null;
    if (playerData?.invoicingOption === 'Individual') eInvoiceInfo = playerData?.einvoiceEntityIndividual;
    else if (playerData?.invoicingOption === 'Company') eInvoiceInfo = playerData?.einvoiceEntityCompany;
    else return false;

    // console.debug('on validate player e-invoice', eInvoiceInfo);
    if (eInvoiceInfo?.taxIdentificationNumber?.length) return true;
    else return false;
  }

  onValidateEInvoice() {
    const einvoiceEntity: EInvoicingSetup = this.selectedInvoicePlayer?.einvoiceEntity;
    let validation = {
      success: true,
      messages: null,
    };
    let messages = [];
    if (einvoiceEntity?.individual === true) {
      if (!einvoiceEntity?.idType || einvoiceEntity?.idType?.length === 0) {
        messages.push('Missing ID Type');
      }
      if (!einvoiceEntity?.idValue || einvoiceEntity?.idValue?.length === 0) {
        messages.push('Missing ID Value');
      }
    }
    if (!einvoiceEntity?.name || einvoiceEntity?.name?.length === 0) {
      messages.push('Missing Name');
    }
    if (!einvoiceEntity?.taxIdentificationNumber || einvoiceEntity?.taxIdentificationNumber?.length === 0) {
      messages.push('Missing Tax Identification Number (TIN)');
    }
    if (einvoiceEntity?.individual === false) {
      if (!einvoiceEntity?.businessRegistrationNumber || einvoiceEntity?.businessRegistrationNumber?.length === 0) {
        messages.push('Missing Business Registration Number (BRN/SSM)');
      }
    }
    if (!einvoiceEntity?.country || einvoiceEntity?.country?.length === 0) {
      messages.push('Missing Country');
    }
    if (!einvoiceEntity?.address?.state) {
      messages.push('Missing State');
    }
    if (!einvoiceEntity?.address?.city) {
      messages.push('Missing City');
    }
    if (messages?.length) {
      validation = {
        success: false,
        messages: messages,
      };
    }
    // console.debug('on validate e-invoice', this.selectedInvoicePlayer, validation, messages);
    return validation;
  }

  onSelectInvoicePlayerByBooking(tbookingPlayer: TeeTimeBookingPlayer) {
    this.selectedInvoicePlayer['playerId'] = null;
    this.selectedInvoicePlayer['bookingPlayerId'] = null;
    // if (this.addInvoiceCustomerType === 'booking') this.selectedInvoicePlayer['bookingPlayerId'] = tbookingPlayer?.id;
    // else if (this.addInvoiceCustomerType === 'mg2u') this.selectedInvoicePlayer['playerId'] = tbookingPlayer?.player?.id;
    if (tbookingPlayer?.player) {
      this.selectedInvoicePlayer['playerId'] = tbookingPlayer?.player?.id;
      this.selectedInvoicePlayer['bookingPlayerId'] = tbookingPlayer?.id;
    } else this.selectedInvoicePlayer['bookingPlayerId'] = tbookingPlayer?.id;

    this.selectedInvoicePlayer.einvoiceEntity = null;
    let eInvoiceInfo: EInvoicingEntity;
    if (tbookingPlayer?.player) {
      const playerId = tbookingPlayer?.player?.id;
      this.getPlayerDetails(playerId).then((result: any) => {
        if (result) {
          const playerData = result;
          this.selectedInvoicePlayer['playerData'] = playerData;
          if (playerData?.invoicingOption === 'Individual') eInvoiceInfo = playerData?.einvoiceEntityIndividual;
          else if (playerData?.invoicingOption === 'Company') eInvoiceInfo = playerData?.einvoiceEntityCompany;
          if (eInvoiceInfo)
            this.selectedInvoicePlayer.einvoiceEntity = {
              taxIdentificationNumber: eInvoiceInfo?.taxIdentificationNumber,
              individual: playerData?.invoicingOption === 'Individual' ? true : false,
              name: eInvoiceInfo?.name,
              businessRegistrationNumber: eInvoiceInfo?.businessRegistrationNumber,
              tourismNumber: eInvoiceInfo?.tourismNumber,
              country: eInvoiceInfo?.country?.id,
              address: {
                addressLine1: eInvoiceInfo?.address?.address1,
                addressLine2: eInvoiceInfo?.address?.address2,
                city: eInvoiceInfo?.address?.city,
                state: eInvoiceInfo?.address?.state,
                postCode: eInvoiceInfo?.address?.postCode,
                email: eInvoiceInfo?.address?.email,
                phone: eInvoiceInfo?.address?.phone1,
              },
              idType: eInvoiceInfo?.idType,
              idValue: eInvoiceInfo?.idValue,
              stdIndustrialCode: eInvoiceInfo?.stdIndustrialCode,
              sst: eInvoiceInfo?.sst,
            };
        }
      });
    }
  }

  onSelectInvoicePlayerByList(player) {
    this.onClubPlayerSelect();
  }
  // onToggleInvoicePlayer(tbookingPlayer: TeeTimeBookingPlayer) {
  //   let _selectedIndex = this.selectedInvoicePlayers.findIndex((sp, index) => {
  //     return sp?.id === tbookingPlayer?.id;
  //   });
  //   if (_selectedIndex > -1) {
  //     this.selectedInvoicePlayers.splice(_selectedIndex, 1);
  //   } else {
  //     this.selectedInvoicePlayers.push(tbookingPlayer);
  //   }
  //   console.debug('toggling invoice player : ', tbookingPlayer, this.selectedInvoicePlayers);
  // }

  onTogglePlayer(tbookingPlayer: TeeTimeBookingPlayer) {
    let _selectedIndex = this.selectedPlayers.findIndex((sp, index) => {
      return sp?.id === tbookingPlayer?.id;
    });
    if (_selectedIndex > -1) {
      this.selectedPlayers.splice(_selectedIndex, 1);
    } else {
      this.selectedPlayers.push(tbookingPlayer);
    }
    if (this.selectedPlayers?.length === 0) this.toggleAllPlayers = false;
    if (this.selectedPlayers?.length === this.filteredBookingPlayers()?.length) this.toggleAllPlayers = true;
    // console.debug('toggling player : ', tbookingPlayer, this.selectedPlayers);
  }

  isSelectedInvoicePlayer(tbookingPlayer: TeeTimeBookingPlayer) {
    // console.debug('is selected invoice player : ', tbookingPlayer, this.selectedInvoicePlayers);
    if (!this.selectedInvoicePlayers) return;
    let _selectedIndex = this.selectedInvoicePlayers.findIndex((sp, index) => {
      return sp?.id === tbookingPlayer?.id;
    });
    return _selectedIndex > -1;
  }

  isSelectedPlayer(tbookingPlayer: TeeTimeBookingPlayer) {
    // console.debug('is selected player : ', tbookingPlayer, this.selectedPlayers);
    if (!this.selectedPlayers) return;
    let _selectedIndex = this.selectedPlayers.findIndex((sp, index) => {
      return sp?.id === tbookingPlayer?.id;
    });
    return _selectedIndex > -1;
  }
  onIncludeEInvoice() {
    // const playerData = this.playerList.find(p => p?.id === this.selectedPlayers[0]?.player?.id);
    const playerData = this.selectedInvoicePlayer?.playerData;
    let eInvoiceInfo: EInvoicingEntity = null;
    let eInvoiceSetup: EInvoicingSetup = this.selectedInvoicePlayer?.einvoiceEntity;
    eInvoiceSetup.address.address1 = this.selectedInvoicePlayer?.einvoiceEntity?.address?.addressLine1;
    eInvoiceSetup.address.address2 = this.selectedInvoicePlayer?.einvoiceEntity?.address?.addressLine2;
    delete eInvoiceSetup.address.addressLine1;
    delete eInvoiceSetup.address.addressLine2;
    // if(playerData) {
    //   if (playerData?.invoicingOption === 'Individual') eInvoiceInfo = playerData?.einvoiceEntityIndividual;
    //   else if (playerData?.invoicingOption === 'Company') eInvoiceInfo = playerData?.einvoiceEntityCompany;
    // } else {
    // }
    if (eInvoiceSetup?.businessRegistrationNumber === undefined || eInvoiceSetup?.businessRegistrationNumber === null)
      eInvoiceSetup.businessRegistrationNumber = null;
    if (eInvoiceSetup?.tourismNumber === undefined || eInvoiceSetup?.tourismNumber === null) eInvoiceSetup.tourismNumber = null;
    if (eInvoiceSetup?.stdIndustrialCode === undefined || eInvoiceSetup?.stdIndustrialCode === null) eInvoiceSetup.stdIndustrialCode = null;
    if (eInvoiceSetup?.sst === undefined || eInvoiceSetup?.sst === null) eInvoiceSetup.sst = null;

    const eInvoiceDTO = {
      bookingPlayerId: this.selectedInvoicePlayer?.bookingPlayerId, // this.selectedPlayers[0]?.id,
      playerId: this.selectedInvoicePlayer?.playerId, // this.selectedPlayers[0]?.player?.id || null,
      bookingPlayerIds: this.selectedPlayers?.map(tbp => tbp.id),
      clienteInvoiceEntity: eInvoiceSetup, // this.selectedPlayers[0]?.player
      einvoiceEntity: eInvoiceSetup, // this.selectedPlayers[0]?.player
    };
    if (eInvoiceDTO?.playerId === null) delete eInvoiceDTO?.playerId;
    if (eInvoiceSetup?.sst?.length) eInvoiceSetup.SST = eInvoiceSetup.sst;
    console.debug('on include e-invoice ', eInvoiceDTO);
    this.teeBookingEInvoicePlayerDTO.push(eInvoiceDTO);
    this.selectedPlayers = [];
    this.selectedInvoicePlayer = {
      bookingPlayerId: null,
      playerId: null,
      einvoiceEntity: null,
      playerData: null,
    };
  }

  filteredBookingPlayers() {
    const availablePlayers = this.bookingPlayers?.filter(bp => {
      return !this.teeBookingEInvoicePlayerDTO.some(tbeinv => tbeinv?.bookingPlayerIds?.some(bpid => bpid === bp?.id));
      // return !this.selectedPlayers.some(sp => sp?.id === bp?.id);
    });
    return availablePlayers;
  }

  filteredInvoicePlayers() {
    const invoicePlayers = this.bookingPlayers?.filter(bp => {
      return (
        // !this.teeBookingEInvoicePlayerDTO.some(tbeinv => tbeinv?.bookingPlayerIds?.some(bpid => bpid === bp?.id)) &&
        !this.teeBookingEInvoicePlayerDTO.some(tbeinv => tbeinv?.bookingPlayerId === bp?.id)
      );
    });
    return invoicePlayers;
  }

  onRemoveInvoice(invoice: TBookingEInvoicePlayerDTO) {
    console.debug('on remove invoice ', invoice, this.teeBookingEInvoicePlayerDTO);
    let _selectedIndex = this.teeBookingEInvoicePlayerDTO.findIndex((tinv, index) => {
      return tinv?.bookingPlayerId === invoice?.bookingPlayerId;
    });
    if (_selectedIndex > -1) {
      this.teeBookingEInvoicePlayerDTO.splice(_selectedIndex, 1);
    }
    // else {
    //   this.selectedPlayers.push(tbookingPlayer);
    // }
  }
  toggleAllPlayers: boolean = false;
  onSelectAllPlayers() {
    if (this.toggleAllPlayers) {
      this.selectedPlayers = [];
      this.selectedPlayers.push(...this.filteredBookingPlayers());
    } else {
      this.selectedPlayers = [];
    }
  }

  getPlayerInfo(tbookingPlayer: TeeTimeBookingPlayer, attribute: string) {
    const playerData = this.playerList.find(p => p?.id === tbookingPlayer?.player?.id);
    let eInvoiceInfo: EInvoicingEntity = null;
    if (playerData?.invoicingOption === 'Individual') eInvoiceInfo = playerData?.einvoiceEntityIndividual;
    else if (playerData?.invoicingOption === 'Company') eInvoiceInfo = playerData?.einvoiceEntityCompany;
    switch (attribute) {
      case 'playerId':
        // if (tbookingPlayer?.player) return `# ${tbookingPlayer?.player?.id}`;
        if (playerData?.id) return `#${playerData?.id}`;
        else return '';
      case 'playerName':
        return tbookingPlayer?.playerName;
      case 'legalName':
        return eInvoiceInfo?.name;
      case 'tinNumber':
        return eInvoiceInfo?.taxIdentificationNumber;
      case 'idType':
        return eInvoiceInfo?.idType;
      case 'idValue':
        return eInvoiceInfo?.idValue;
      case 'brnNumber':
        return eInvoiceInfo?.businessRegistrationNumber;
      case 'state':
        return eInvoiceInfo?.address?.state;
      case 'country':
        return eInvoiceInfo?.address?.countryData?.name;
      case 'postCode':
        return eInvoiceInfo?.address?.postCode;
    }
  }

  getEInvoiceEntity(eInvoiceSetup: EInvoicingSetup, attribute: string) {
    // eInvoiceInfo: EInvoicingEntity
    console.debug('get einvoice entity : ', eInvoiceSetup);
    let _eInvoiceInfo = eInvoiceSetup;
    // const address = eInvoiceInfo?.address;
    // let _eInvoiceInfo: EInvoicingSetup = {
    //   taxIdentificationNumber: eInvoiceInfo?.taxIdentificationNumber,
    //   individual: eInvoiceInfo?.individual,
    //   name: eInvoiceInfo?.name,
    //   businessRegistrationNumber: eInvoiceInfo?.businessRegistrationNumber,
    //   tourismNumber: eInvoiceInfo?.tourismNumber,
    //   country: eInvoiceInfo?.country?.id,
    //   address: {
    //     addressLine1: address?.address1,
    //     addressLine2: address?.address2,
    //     city: address?.city,
    //     state: address?.city,
    //     postcode: address?.postCode,
    //     email: address?.email,
    //     phone: address?.phone1,
    //   },
    // };
    switch (attribute) {
      case 'legalName':
        return _eInvoiceInfo?.name;
      case 'tinNumber':
        return _eInvoiceInfo?.taxIdentificationNumber;
      case 'idType':
        return `[${this.capitalizeFirstLetter(_eInvoiceInfo?.idType)}]`;
      case 'idValue':
        return _eInvoiceInfo?.idValue;
      case 'brnNumber':
        return _eInvoiceInfo?.businessRegistrationNumber;
      case 'state':
        return _eInvoiceInfo?.address?.state;
      case 'country':
        return _eInvoiceInfo?.country;
      case 'postCode':
        return _eInvoiceInfo?.address?.postCode;
    }
  }

  async onUpdateEInvoiceInfo() {
    const einvoiceEntity: EInvoicingSetup = this.selectedInvoicePlayer?.einvoiceEntity;
    console.debug('on update einvoice info [0] : ', this.selectedInvoicePlayer);
    console.debug('on update einvoice info [1] : ', einvoiceEntity);
    let modal = await this.modalCtl.create({
      component: EInvoiceInfoPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        playerData: null,
        type: 'updateSetup',
        mode: 'edit',
        einvoiceEntity: einvoiceEntity,
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data?.data) {
        this.selectedInvoicePlayer.einvoiceEntity = data?.data;
        if (data?.data?.eInvoicingOption === 'Individual') this.selectedInvoicePlayer.einvoiceEntity.individual = true;
        else this.selectedInvoicePlayer.einvoiceEntity.individual = false;
        console.debug('dismiss add einvoice', data, this.selectedInvoicePlayer);
      }
    });
    modal.present();
  }

  async onAddEInvoiceInfo() {
    const playerData = this.selectedInvoicePlayer?.playerData;
    let modal = await this.modalCtl.create({
      component: EInvoiceInfoPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        playerData: playerData,
        type: 'updateSetup',
        mode: 'add',
      },
    });
    modal.onDidDismiss().then((data: any) => {
      if (data?.data) {
        this.selectedInvoicePlayer.einvoiceEntity = data?.data;
        if (data?.data?.eInvoicingOption === 'Individual') this.selectedInvoicePlayer.einvoiceEntity.individual = true;
        else this.selectedInvoicePlayer.einvoiceEntity.individual = false;
        console.debug('dismiss add einvoice', data, this.selectedInvoicePlayer);
      }
    });
    modal.present();
  }

  onChangeAddInvoiceCustomerType(addInvoiceCustomerType: string) {
    this.addInvoiceCustomerType = addInvoiceCustomerType;
    if (addInvoiceCustomerType === 'adhoc' && this.selectedInvoicePlayer?.einvoiceEntity) {
      this.selectedInvoicePlayer.bookingPlayerId = null;
      this.selectedInvoicePlayer.playerId = null;
      this.selectedInvoicePlayer.einvoiceEntity = null;
      this.selectedInvoicePlayer.playerData = null;
    }
  }
  initEInvoicingSetup() {}

  constructEInvoicingSetup() {}

  canGenerate() {
    if (this.invoiceType === 'order') {
      return this.hasCompleteEInvoice();
    } else {
      const totalBookingPlayers = this.bookingPlayers?.length;
      let _invoicingTotalPlayers = 0;
      this.teeBookingEInvoicePlayerDTO?.forEach(tbeinv => {
        _invoicingTotalPlayers += tbeinv?.bookingPlayerIds?.length;
      });
      return _invoicingTotalPlayers === totalBookingPlayers;
    }
  }

  onGenerate() {
    if (this.invoiceType === 'order') {
      const orderId = this.orderDetails?.id;
      const einvoiceSetup = this.selectedInvoicePlayer?.einvoiceEntity;
      console.debug('on generate - ', this.invoiceType, einvoiceSetup, this.selectedInvoicePlayer);
      this.flightService.saveOrderEInvoiceSetup(orderId, einvoiceSetup).subscribe(data => {
        if (data) {
          MessageDisplayUtil.showMessageToast(
            'Succesfully requested for e-Invoice generation',
            this.platform,
            this.toastCtrl,
            3000,
            'bottom'
          );
          this.modalCtl.dismiss();
        }
      });
    } else {
      // santize payload
      this.teeBookingEInvoicePlayerDTO?.forEach(tbeinv => {
        delete tbeinv['clienteInvoiceEntity'];
        if (tbeinv?.einvoiceEntity) delete tbeinv?.einvoiceEntity['eInvoicingOption'];
      });
      const bookingId = this.bookingSlot?.id;
      this.flightService.saveBookingEInvoiceSetup(bookingId, this.teeBookingEInvoicePlayerDTO).subscribe(data => {
        if (data) {
          MessageDisplayUtil.showMessageToast(
            'Succesfully requested for e-Invoice generation',
            this.platform,
            this.toastCtrl,
            3000,
            'bottom'
          );
          this.modalCtl.dismiss();
        }
      });
    }
  }

  capitalizeFirstLetter(text?: string) {
    return this.mg2uUtils.capitalizeFirstLetter(text, true);
  }

  async onClubPlayerSelect() {
    const clubModal = await this.modalCtl.create({
      component: AddPlayerListPage,
      cssClass: 'ion-infinite-scorll',
      mode: 'ios',
      componentProps: {
        openedModal: true,
        fromClub: true,
        maxPlayers: 1,
        forBooking: false,
        clubId: this.bookingSlot?.clubData?.id, // this.orderDetails?.clubLite.clubId,
        noNewPlayer: true,
      },
    });

    clubModal.onDidDismiss().then((data: any) => {
      if (data?.data) {
        console.log('data', data?.data); //
        this.selectedInvoicePlayer.playerId = data?.data?.item?.playerId;

        this.selectedInvoicePlayer.einvoiceEntity = null;
        let eInvoiceInfo: EInvoicingEntity;
        if (this.selectedInvoicePlayer.playerId) {
          const playerId = this.selectedInvoicePlayer.playerId;
          this.getPlayerDetails(playerId).then((result: any) => {
            if (result) {
              const playerData = result;
              this.selectedInvoicePlayer['playerData'] = playerData;
              if (playerData?.invoicingOption === 'Individual') eInvoiceInfo = playerData?.einvoiceEntityIndividual;
              else if (playerData?.invoicingOption === 'Company') eInvoiceInfo = playerData?.einvoiceEntityCompany;
              if (eInvoiceInfo)
                this.selectedInvoicePlayer.einvoiceEntity = {
                  taxIdentificationNumber: eInvoiceInfo?.taxIdentificationNumber,
                  individual: playerData?.invoicingOption === 'Individual' ? true : false,
                  name: eInvoiceInfo?.name,
                  businessRegistrationNumber: eInvoiceInfo?.businessRegistrationNumber,
                  tourismNumber: eInvoiceInfo?.tourismNumber,
                  country: eInvoiceInfo?.country?.id,
                  address: {
                    addressLine1: eInvoiceInfo?.address?.address1,
                    addressLine2: eInvoiceInfo?.address?.address2,
                    city: eInvoiceInfo?.address?.city,
                    state: eInvoiceInfo?.address?.state,
                    postCode: eInvoiceInfo?.address?.postCode,
                    email: eInvoiceInfo?.address?.email,
                    phone: eInvoiceInfo?.address?.phone1,
                  },
                  idType: eInvoiceInfo?.idType,
                  idValue: eInvoiceInfo?.idValue,
                  stdIndustrialCode: eInvoiceInfo?.stdIndustrialCode,
                  sst: eInvoiceInfo?.sst,
                };
            }
          });
        }
        // let _clubId = this.orderDetails?.clubLite.clubId;
        // let _orderId = this.orderDetails?.id;
        // let _params = {
        //   orderDate: this.orderDetails.orderDate,
        //   playerId: this.selectedPlayer.playerId,
        // };

        // this.flightService.updateClubOrderDetails(_clubId, _orderId, _params).subscribe(
        //   data => {
        //     if (data) {
        //       console.log(data, 'data');
        //       this.orderDetails.customerEmail = data?.customerEmail;
        //       this.orderDetails.customerGender = data?.customerGender;
        //       this.orderDetails.customerName = data?.customerName;
        //       this.orderDetails.customerPhone = data?.customerPhone;
        //       this.orderDetails.partner = null;
        //       this.orderDetails.clubCustomer = null;
        //       this.orderDetails.orderUser = data?.orderUser;
        //       this.orderDetails.playerLite = data?.playerLite;
        //     }
        //   },
        //   error => {
        //     let _msg = getErrorMessage(error);

        //     MessageDisplayUtil.showMessageToast(_msg, this.platform, this.toastCtl, 5000, 'bottom');
        //     return false;
        //   }
        // );
      }
    });
    clubModal.present();
  }

  getOrderCustomerInfo(attribute?: string) {
    if (!this.orderDetails) return;
    // player | partner | clubCustomer | customer
    let customerInfo;
    if (this.orderDetails?.player) {
      customerInfo = {
        name: this.orderDetails?.player?.playerName,
        email: this.orderDetails?.player?.email,
        phone: this.orderDetails?.player?.phone,
      };
    } else if (this.orderDetails?.partner) {
      customerInfo = {
        name: this.orderDetails?.partner?.name,
        email: this.orderDetails?.partner?.emailList,
        phone: this.orderDetails?.partner?.address?.phone1,
      };
    } else if (this.orderDetails?.clubCustomer) {
      customerInfo = {
        name: this.orderDetails?.clubCustomer?.customerName,
        email: this.orderDetails?.clubCustomer?.customerEmail,
        phone: this.orderDetails?.clubCustomer?.customerPhone,
      };
    } else if (this.orderDetails?.customerName) {
      customerInfo = {
        name: this.orderDetails?.customerName,
        email: this.orderDetails?.customerEmail,
        phone: this.orderDetails?.customerPhone,
      };
    }

    switch (attribute) {
      case 'name':
        return customerInfo?.name;
      case 'email':
        return customerInfo?.email;
      case 'phone':
        return customerInfo?.phone;
      default:
        return customerInfo;
    }
  }

  getClubCustomerEInvoiceEntity(): EInvoicingSetup {
    if (!this.orderDetails) return;
    if (!this.orderDetails?.clubCustomer?.einvoicingEntity) return;
    const einvoicingEntity: EInvoicingEntity = this.orderDetails?.clubCustomer?.einvoicingEntity;
    const eInvoiceSetup: EInvoicingSetup = {
      taxIdentificationNumber: einvoicingEntity?.taxIdentificationNumber,
      individual: einvoicingEntity?.individual,
      name: einvoicingEntity?.name,
      businessRegistrationNumber: einvoicingEntity?.businessRegistrationNumber,
      tourismNumber: einvoicingEntity?.tourismNumber,
      country: einvoicingEntity?.country?.id,
      address: {
        addressLine1: einvoicingEntity?.address?.address1,
        addressLine2: einvoicingEntity?.address?.address2,
        city: einvoicingEntity?.address?.city,
        state: einvoicingEntity?.address?.state,
        postCode: einvoicingEntity?.address?.postCode,
        email: einvoicingEntity?.address?.email,
        phone: einvoicingEntity?.address?.phone1,
      },
      idType: einvoicingEntity?.idType,
      idValue: einvoicingEntity?.idValue,
      stdIndustrialCode: einvoicingEntity?.stdIndustrialCode,
      sst: einvoicingEntity?.sst,
    };
    return eInvoiceSetup;
  }
}
